import { resolveProductImage } from "./productAssets";

const CART_KEY = "bobbinusa_cart";
export const CART_UPDATED_EVENT = "bobbinusa_cart_updated";
const CHECKOUT_KEY = "bobbinusa_checkout";
const CONFIRMED_ORDER_KEY = "bobbinusa_last_order";

export const fallbackCartItem = {
  name: "New Tension Complete Singer 20U Zig Zag",
  seller: "Bobbinusa.com",
  sku: "S20U-TENSION-COMP",
  condition: "New",
  price: 17.95,
  quantity: 1,
  image: "/uploads/catalog/hotproducts/1.png",
};

export function formatMoney(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(value || 0));
}

export function productToCartItem(product, quantity = 1, variant = null, selectedOptions = {}) {
  const variantPrice = Number(variant?.price || 0) > 0 ? variant.price : product?.price;
  const variantSku = variant?.sku || product?.sku || fallbackCartItem.sku;

  return {
    productId: product?._id,
    variantId: variant?._id,
    variantName: variant?.name,
    selectedOptions: selectedOptions || variant?.attributes || {},
    name: product?.name || fallbackCartItem.name,
    seller: "Bobbinusa.com",
    sku: variantSku,
    condition: product?.condition || "New",
    price: Number(variantPrice || fallbackCartItem.price),
    quantity: Math.max(1, Number(quantity || 1)),
    image: variant?.image || product?.image || fallbackCartItem.image,
    weightLb: Number(variant?.weightLb ?? product?.weightLb ?? 1),
  };
}

function safeParse(value, fallback) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function readCartItem() {
  return safeParse(localStorage.getItem(CART_KEY), null);
}

export function writeCartItem(item) {
  localStorage.setItem(CART_KEY, JSON.stringify(item));
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
}

export function clearCartItem() {
  localStorage.removeItem(CART_KEY);
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
}

export function getCartImage(item) {
  return resolveProductImage(item?.image || fallbackCartItem.image);
}

export function calculateSummary(item, shipping = 0, discountPercent = 0) {
  const subtotal = Number((Number(item?.price || 0) * Number(item?.quantity || 1)).toFixed(2));
  const safeDiscountPercent = Math.max(0, Math.min(100, Number(discountPercent || 0)));
  const discount = Number(((subtotal * safeDiscountPercent) / 100).toFixed(2));
  const taxableSubtotal = Math.max(0, subtotal - discount);
  const tax = Number((taxableSubtotal * 0.08).toFixed(2));
  const total = Number((taxableSubtotal + Number(shipping || 0) + tax).toFixed(2));
  return { subtotal, discount, discountPercent: safeDiscountPercent, shipping: Number(shipping || 0), tax, total };
}

export function writeCheckoutDraft(draft) {
  localStorage.setItem(CHECKOUT_KEY, JSON.stringify(draft));
}

export function readCheckoutDraft() {
  return safeParse(localStorage.getItem(CHECKOUT_KEY), null);
}

export function writeConfirmedOrder(order) {
  localStorage.setItem(CONFIRMED_ORDER_KEY, JSON.stringify(order));
}

export function readConfirmedOrder() {
  return safeParse(localStorage.getItem(CONFIRMED_ORDER_KEY), null);
}
